import AppDb from '../database/database';

//TODO: wtf is this? maybe could be merged with map filter??
export default {
    SEARCH_IN: {
        PLANTS: AppDb.tables.PLANTS.name,
        ARTICLES: AppDb.tables.ARTICLES.name
    },
    SEARCH_IN_DATABASES: {
        plants: AppDb.tables.SEARCH_INDEX.name,
        expositions: AppDb.tables.SEARCH_INDEX.name,
    }
}


// WEBPACK FOOTER //
// ./src/const/search.js